import React from "react";
import { DateTime, Eyebrow, Heading, Image, getClassNameFactory } from "../../../../";
import ArticleInfoFooter from "./components/ArticleInfoFooter";
import TagFooter from "./components/TagFooter";
import { Sizes, Rank } from "../../../../core";

var Result = function Result(_ref) {
  var dateTime = _ref.dateTime,
      description = _ref.description,
      eyebrow = _ref.eyebrow,
      footer = _ref.footer,
      href = _ref.href,
      imgSrc = _ref.imgSrc,
      imgSrcSet = _ref.imgSrcSet,
      links = _ref.links,
      title = _ref.title;
  var getClassName = getClassNameFactory("SearchResults");
  /** TODO: break this render into smaller components */

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "result"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "resultBody"
    })
  }, dateTime && !eyebrow && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "resultDateTime",
      utilities: "typographySmallCaps"
    })
  }, /*#__PURE__*/React.createElement(DateTime, {
    dateTime: dateTime
  })), eyebrow && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "resultEyebrow"
    })
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    text: eyebrow
  })), /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "resultTitle"
    }),
    href: href
  }, /*#__PURE__*/React.createElement(Heading, {
    rank: Rank.Third,
    type: Sizes.SMALL
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "resultDescription"
    })
  }, description), footer && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "resultFooter"
    })
  }, footer), links && links.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "resultLinks"
    })
  }, links.map(function (link, i) {
    return /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "resultLink"
      }),
      key: i
    }, link);
  }))), imgSrc && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "resultImage"
    })
  }, /*#__PURE__*/React.createElement(Image, {
    sizes: "calc(364rem / 16)",
    src: imgSrc,
    srcSet: imgSrcSet,
    alt: "Result image",
    fit: "cover"
  })));
};

Result.displayName = "SearchResults.Result";
Result.ArticleInfoFooter = ArticleInfoFooter;
Result.TagFooter = TagFooter;
export default Result;